export default __webpack_public_path__ + "static/media/c008-3.3f65ae00.svg";